import { render, staticRenderFns } from "./IphonePostForm.vue?vue&type=template&id=5f449336&scoped=true&"
import script from "./IphonePostForm.vue?vue&type=script&lang=js&"
export * from "./IphonePostForm.vue?vue&type=script&lang=js&"
import style0 from "./IphonePostForm.vue?vue&type=style&index=0&id=5f449336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f449336",
  null
  
)

export default component.exports